import { useTeam } from 'app/frontend/base/config/context/team'
import { useDefaultOverviewTiles } from './defaults'
import { hasAccessToContent } from 'app/frontend/base/components/ProtectedContent'
import { overviewTileTypes } from 'app/frontend/types/custom/OverviewTileType'
import { useOverviewData, usePageInfo } from 'app/frontend/base/config/queries'
import LinkButton from '@/components/ui/link-button'
import OverviewPage from 'app/frontend/base/pages/shared/Overview/OverviewPage'
import { uploadFile } from 'app/frontend/base/api/team'

const TeamOverview = () => {
  const { team, guild } = useTeam()
  const defaultTiles = useDefaultOverviewTiles()
  const allowedTeamTileTypes = overviewTileTypes.filter(
    (type) => type !== 'Tile::TeamSummary',
  )
  const { data: overviewData, isLoading: isOverviewDataLoading } =
    useOverviewData(team.id)
  const {
    data: { user },
  } = usePageInfo()

  const { hasAccess: isAdmin } = hasAccessToContent(
    'admin',
    'base',
    guild,
    team,
  )
  const hasCharacterInTeam =
    user?.teamReferences.some(
      (teamReference) => teamReference.id === team.id,
    ) ?? false
  const showApplyButton =
    !!user &&
    !hasCharacterInTeam &&
    team.settings.displayApplyButtonInOverview.value

  return (
    <OverviewPage
      title={`${team.name} | ${guild.name}`}
      entity={team}
      entityType='team'
      isAdmin={isAdmin}
      defaultTiles={defaultTiles}
      allowedTileTypes={allowedTeamTileTypes}
      runtime={{
        overviewData,
        isOverviewDataLoading,
        ownerPath: team.path,
        ownerName: team.name,
        guildMotd: guild.motd,
        teamReference: team,
        uploadFile: async (file) => (await uploadFile(team.id, file)).url,
        recentNewsEditPermission: {
          section: 'news',
          requirement: 'admin',
        },
      }}
      sidebarContent={
        showApplyButton ? (
          <LinkButton
            to={`${team.path}/apply`}
            className='w-full mb-4'
            variant={'default'}
          >
            Apply to team
          </LinkButton>
        ) : undefined
      }
    />
  )
}

export default TeamOverview
